import {useContext} from "react";
import {observer} from "mobx-react";
import {YStack} from "@chayka/ui";
import {SignUpFirstStep} from "./First";
import {SignUpSecondStep} from "./Second";
import {SignUpHeader} from "./Header";
import {SignUpStateContext} from "./state";

export const SignUpPage = observer(() => {
  const {step, goToNext} = useContext(SignUpStateContext);

  return (
    <YStack className="relative justify-start items-center gap-5 w-full h-full">
      <SignUpHeader />
      <YStack className="relative flex-1 justify-start items-stretch gap-5 w-full h-full">
        {step === "first" && <SignUpFirstStep onNext={goToNext} />}
        {step === "second" && <SignUpSecondStep />}
      </YStack>
    </YStack>
  );
});
